import type {
  NotificationPreferencesInput,
  NotificationPreferencesResponse,
} from '@wundo/shared/notificationPreferences.ts';
import { apiFetchJson } from '@wundo/client/api.ts';

export type { NotificationPreferencesInput, NotificationPreferencesResponse };

export async function fetchNotificationPreferences(): Promise<NotificationPreferencesResponse> {
  return apiFetchJson<NotificationPreferencesResponse>('/notification-preferences');
}

export async function saveNotificationPreferences(
  preferences: NotificationPreferencesInput,
): Promise<NotificationPreferencesResponse> {
  return apiFetchJson<NotificationPreferencesResponse>('/notification-preferences', {
    method: 'PUT',
    body: JSON.stringify(preferences),
  });
}
